<template>
	<div>
		<div class="row justify-content-between mt-4 mx-4">
			<h6 class="font-weight-bold"> List of Menus</h6>
			<button @click="$emit('showlist')" class="btn btn-secondary btn-sm mr-3 px-4">
				<span> &lt; Back</span>
			</button>
		</div>

		<!-- List of Menus and sub-menus -->
		<section class="row justify-content-between px-4 mt-4">
			<div class="col-md-4 pl-4">
				<p class="border-bottom py-2"><span class="font-weight-lighter">Admin ID:</span> {{adminData.adminId}}</p>
				<p class="border-bottom py-2"><span class="font-weight-lighter">Admin name:</span> {{adminData.firstName}} {{adminData.firstName}}</p>
				<p class="border-bottom py-2"><span class="font-weight-lighter">Admin Email:</span> {{adminData.email}}</p>
				<p class="border-bottom py-2"><span class="font-weight-lighter">Admin Phone:</span> {{adminData.phone}}</p>
			</div>
			
			<form action="#" @submit.prevent class="col-md-7 border-left">
				<h6 class="mb-4">Choose Menus</h6>
				<div v-for="(menu, i) in  filteredMenuList" :key="i" class="form-group form-check border-bottom">
					<input type="checkbox" :checked="menu.checked" :value="menu.id" @change="selectAllSub" class="form-check-input" :id="'menu'+menu.id">
					<label class="form-check-label" :for="'menu'+menu.id">{{ menu.menuName }}</label>

					<!-- for subMenus -->
					<div v-for="(submenu, i) in  menu.subMenus" :key="i" class="form-group form-check ml-3">
						<input type="checkbox" :checked="submenu.checked" :value="menu.id+'_'+submenu.id" @change="selectOneSub" class="form-check-input" :id="'submenu'+submenu.id" :class="'menu'+menu.id">
						<label class="form-check-label" :for="'submenu'+submenu.id">{{ submenu.subMenuName }}</label>
					</div>
				</div>

				<div class="form-group mt-5 text-center px-3">
					<button class="btn btn-primary btn-sm w-100" :disabled="!this.selectedMenus.length || assigning" type="submit" @click.prevent="assignMenu()"> 
						<span class="mr-3">Assign Menu</span>
						<span v-if="assigning" class="spinner-border spinner-border-sm" role="status">
							<span class="sr-only">Loading...</span>
						</span>
					</button>
				</div>

				<!-- <pre>{{filteredMenuList}}</pre> -->
			</form>
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: "AssignAdmin",

	props: {
		menuList: Array,
		adminData: Object,
		adminMenu: Array,
	},

	computed:{
        ...mapState(['token'])
    },

	data(){
		return {
			assigning: false,
			selectedMenus: [],
			filteredMenuList: [],
		}
	},

	mounted(){
		this.filterMenu();
	},

	methods: {

		filterMenu() {
			this.filteredMenuList = this.menuList.map(menu => {
				if (menu.hasSubMenu == 0) {
					const isChecked = this.adminMenu.findIndex(aMenu => aMenu.menuId == menu.id) >= 0 ? true: false;

					if(isChecked) {
						this.selectedMenus.push({
							adminId: this.adminData.adminId,
							status: 1,
							menuId: menu.id,
							subMenuId: null,
						});
					}
					
					return {
						...menu,
						checked: isChecked
					}
				}else{
					const subMenus = menu.subMenus;
					let menuStatus = true;

					const newSubMenus = subMenus.map(subMenu => {
						const isChecked = this.adminMenu.findIndex(aMenu => aMenu.subMenuId == subMenu.id) >= 0 ? true: false;

						if(!isChecked) {
							menuStatus = false;
						}else{
							this.selectedMenus.push({
								adminId: this.adminData.adminId,
								status: 1,
								menuId: menu.id,
								subMenuId: subMenu.id,
							});
						}

						return {
							...subMenu,
							checked: isChecked
						}
					});
					
					menu.subMenus = newSubMenus

					return{
						...menu,
						checked: menuStatus
					}
				}
			})
		},

		assignMenu(){
			if (!this.selectedMenus.length) {
				this.$toastr.e("No New Menu added");
				return ;
			}

			this.assigning = true;
			const baseU = `${this.$urlAuth}/menu/assign`;

            this.$http.post(baseU, this.selectedMenus, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
				this.assigning = false;
                if(response.data.data.code =='S201'){
                    this.$toastr.s(response.data.data.message);

                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(err => {
				console.log(err);
				this.assigning = false;
                if(err.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e('Internal server error');
                }
            })
		},

		selectOneSub(e){
			const val = e.target.defaultValue;
			const [menuId, subMenuId] = val.split('_');

			// if box is checked
			if (e.target.checked) {
				// add to the selected
			
				this.selectedMenus.push({
					adminId: this.adminData.adminId,
					status: 1,
					menuId,
					subMenuId,
				});
			}else{ // if box is un-checked
				// remove value from selected
				const dIndex = this.selectedMenus.findIndex(menu => menu.subMenuId == subMenuId)
				this.selectedMenus.splice(dIndex, 1);

				// check if no other submenu in a menu is selected
				const cIndex = this.selectedMenus.findIndex(menu => menu.menuId == menuId);
				if (cIndex < 0) {
					document.querySelector(`#menu${menuId}`).checked = false;
				}
			}

			// console.log(this.selectedMenus);
		},

		selectAllSub(e){
			const menuId =  e.target.defaultValue;

			// indicate that these submenus with the classname has been selected
			const classname = e.target.id;
			const subCheckBoxes = document.querySelectorAll(`.${classname}`);

			// if box is checked
			if (e.target.checked) {
				const menu = this.menuList.find(menu => menu.id == menuId);
				if (menu.hasSubMenu == 0) {
					this.selectedMenus.push({
						adminId: this.adminData.adminId,
						status: 1,
						menuId,
						subMenuId: null,
					});
				}else{
					// delete all submenus of from selected list first, if any
					for (let i = 0; i <= this.selectedMenus.length; i++) {
						const dIndex = this.selectedMenus.findIndex(menu => menu.menuId == menuId);
						if (dIndex >= 0) {
							this.selectedMenus.splice(dIndex, 1);
						}
					}

					// get the submenus from the menu list
					const subMenus = this.menuList.find(menu => menu.id == menuId).subMenus

					// then add all submenu to the selected list
					for (let f = 0; f < subMenus.length; f++) {
						const subMenu = subMenus[f];

						this.selectedMenus.push({
							adminId: this.adminData.adminId,
							status: 1,
							menuId,
							subMenuId: subMenu.id,
						});
					}

					// indicate that submenu boxes are checked
					subCheckBoxes.forEach(box => {
						box.checked = true;
					})
				}
			}else{ // if box is un-checked
				for (let i = 0; i <= this.selectedMenus.length; i++) {
					const dIndex = this.selectedMenus.findIndex(menu => menu.menuId == menuId);
					if (dIndex >= 0) {
						this.selectedMenus.splice(dIndex, 1);
					}
				}

				subCheckBoxes.forEach(box => {
					box.checked = false;
				})
			}

			// console.log(this.selectedMenus);
		},

	}
}
</script>